import { useState, useEffect, useRef, useCallback } from 'react';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { authStatusEnum } from '../../../../store/auth/authSlice';
import CameraComponent from '../../../AttemptAssessmentPage/components/CameraComponent';
import AdaptiveCaptureProvider from './AdaptiveCaptureProvider';
import { useParams } from 'react-router-dom';
import { proctoringImagePost } from '../../../../services/api/auth';
import { adaptiveAssessmentStateType } from '../../../../store/adaptiveAssessment/adaptiveAssessmentSlice';

interface componentProps {
  accessKey: string | undefined;
}

const AdaptiveImageCapture = ({ accessKey }: componentProps) => {
  const { current_question_number, assessmentStarted, current_state } =
    useAppSelector((state) => state.adaptive);
  const authState = useAppSelector((state) => state.auth);
  const photo = useRef<any>(null);

  const [loading, setLoading] = useState(true);

  const showAttempt = authState.status === authStatusEnum.AUTHENITICATED;
  const finished = current_state === adaptiveAssessmentStateType.FINISHED;

  const webcamRef = useRef<any>(null);

  const handlePhotoChange = (val: string) => {
    photo.current = val;
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    return imageSrc;
  }, [webcamRef, loading]);

  const postPhoto = (
    photo: string,
    accessKey: string | undefined,
    questionNo: number
  ) => {
    proctoringImagePost(accessKey, photo, questionNo, true);
  };

  useEffect(() => {
    if (assessmentStarted && photo && photo.current) {
      const questionNo = Math.max(1, current_question_number - 1);
      postPhoto(photo.current, accessKey, questionNo);
      photo.current = null;
    }
  }, [current_question_number, assessmentStarted, accessKey]);

  return (
    <>
      {showAttempt && assessmentStarted && !finished && !loading ? (
        <AdaptiveCaptureProvider
          key={current_question_number}
          setPhoto={handlePhotoChange}
          getPhoto={capture}
        />
      ) : (
        <></>
      )}
      {showAttempt && !finished ? (
        <CameraComponent
          cameraRef={webcamRef}
          onLoad={() => setLoading(false)}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AdaptiveImageCapture;
